(function($){
  var formAjax = {
    init: function(){
      if ($('.form-ajax').length){
        formAjax.initFormAjax();
      }
    },
    initFormAjax: function() {
      $('.form-ajax').each(function(i, o) {
        var $form = $(this).find('.form-layout');
        var ajax_script = $(this).attr('action');
        var $success = $(this).find('.form-success');
        var $submit = $(this).find('btn');

        $(this).submit(function(e) {
          e.preventDefault();
          $(this).find('.is-error').removeClass('is-error');
          $submit.prop('disabled', true);
          $submit.addClass('is-waiting');

          jQuery.post(
            ajax_script,
            $(this).serialize(),
            function(response){
              if(response.status == 'ok') {
                $form.hide();
                $success.show();
                if(window.ga)
                  window.ga('send', 'pageview', '/contact-ok');
              } else if(response.status != '403') {
                $submit.prop('disabled', false);
                $submit.removeClass('is-waiting');
                for(var i = 0 ; i < response.field.length ; i++) {
                  $form.find("label[for='"+response.field[i]+"']").parent().addClass('is-error');
                }
              }
            }, 'json'
          );
        });
      });
    },
  };
  $(document).ready(formAjax.init);
})(jQuery);
